import { Routes, Route } from 'react-router-dom'
import Home from '../pages/Home'
import WorkforceAnalytics from '../pages/WorkforceAnalytics'
import Datasets from '../pages/Datasets'
import Login from '../pages/Login'
import Register from '../pages/Register'
import AcademicAdvising from '../pages/AcademicAdvising'
import Profile from '../pages/Profile'
import ProtectedRoute from '../components/ProtectedRoute'
import Users from '../pages/Users'
import Executions from '../pages/Executions';
import InstitutionalExecutions from '../pages/InstitutionalExecutions';
import EmbedHome from '../pages/EmbedHome';
import PartnerIntegration from '../pages/PartnerIntegration';

export default function AppRoutes() {
    return (
        <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/embed/:instCode" element={<EmbedHome />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Protected Routes */}
            <Route
                path="/workforce-analytics"
                element={
                    <ProtectedRoute>
                        <WorkforceAnalytics />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/academic-hub"
                element={
                    <ProtectedRoute>
                        <AcademicAdvising />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/profile"
                element={
                    <ProtectedRoute>
                        <Profile />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/datasets"
                element={
                    <ProtectedRoute requiredRole="SUPER_ADMIN">
                        <Datasets />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/users"
                element={
                    <ProtectedRoute requiredRole="SUPER_ADMIN">
                        <Users />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/executions"
                element={
                    <ProtectedRoute requiredRole="SUPER_ADMIN">
                        <Executions />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/institutional-executions"
                element={
                    <ProtectedRoute requiredRole="ADMIN">
                        <InstitutionalExecutions />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/partner-integration"
                element={
                    <ProtectedRoute requiredRole="ADMIN">
                        <PartnerIntegration />
                    </ProtectedRoute>
                }
            />
        </Routes>
    )
}

